<template>
  <div>
    <vt-grid
      class="sample-grid my-1"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :dom-layout="domLayout"
    />
  </div>
</template>

<script>
import VtGrid from '@/components/VtGrid/VtGrid'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import samplesServices from '@/api/resources/common/commonSampleService'
import CellGridRichText from '@/components/common/CellGridRichText'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'PatientSamplesTab',
    components: { VtGrid },
    props: {
        casId: { type: Number, required: true },
        patId: { type: Number, required: true }
    },
    data() {
        return {
            domLayout: 'autoHeight',
            rowData: [],
            columnDefs: [
                {
                    type: 'text',
                    headerName: this.$t('component.modalPatientCases.sampleId'),
                    colId: 'sampleNumber',
                    field: 'sampleNumber',
                    headerComponentParams: {
                        template: buildIconHeaderTemplate('fal fa-prescription-bottle pl-1')
                    },
                    minWidth: 60,
                    flex: 1
                },
                {
                    type: 'text',
                    headerName: this.$t('component.modalPatientCases.location'),
                    colId: 'topographicCode.description',
                    field: 'topographicCode.description',
                    flex: 1
                },
                {
                    type: 'text',
                    headerName: this.$t('component.modalPatientCases.sampleType'),
                    colId: 'sampleType.description',
                    field: 'sampleType.description',
                    minWidth: 200,
                    flex: 1
                },
                {
                    type: 'text',
                    headerName: this.$t('component.modalPatientCases.macroscopy'),
                    colId: 'macro.text',
                    field: 'macro.text',
                    cellStyle: { 'white-space': 'normal', 'overflow-y': 'auto' },
                    cellRendererFramework: CellGridRichText,
                    minWidth: 480,
                    width: 500
                },
                {
                    type: 'text',
                    headerName: this.$t('component.modalPatientCases.microscopy'),
                    colId: 'micro.text',
                    field: 'micro.text',
                    cellStyle: { 'white-space': 'normal', 'overflow-y': 'auto' },
                    cellRendererFramework: CellGridRichText,
                    minWidth: 480,
                    width: 500
                },
                {
                    type: 'text',
                    headerName: this.$t('component.modalPatientCases.additionalReport'),
                    colId: 'additionalReport.text',
                    field: 'additionalReport.text',
                    cellStyle: { 'white-space': 'normal', 'overflow-y': 'auto' },
                    cellRendererFramework: CellGridRichText,
                    minWidth: 480,
                    width: 500
                },
                {
                    type: 'text',
                    headerName: this.$t('component.modalPatientCases.diagnose'),
                    colId: 'diagnosis.text',
                    field: 'diagnosis.text',
                    cellStyle: { 'white-space': 'normal', 'overflow-y': 'auto' },
                    cellRendererFramework: CellGridRichText,
                    minWidth: 480,
                    width: 500
                },
                // TODO make cell renderer for codifications
                /* {
                    type: 'text',
                    headerName: this.$t('component.modalPatientCases.topographicCoding'),
                    colId: 'samConservation',
                    field: 'samConservation'
                }, */
                {
                    type: 'text',
                    headerName: this.$t('component.modalPatientCases.observations'),
                    colId: 'observations',
                    field: 'observations',
                    cellStyle: { 'white-space': 'normal', 'overflow-y': 'auto' },
                    cellRendererFramework: CellGridRichText,
                    minWidth: 480,
                    width: 500
                }
            ]
        }
    },
    computed: {
        gridOptions() {
            return {
                floatingFilter: false,
                pagination: false,
                sideBar: gridSideBarConfig,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                getRowHeight: ({ data }) => {
                    // assuming 45 characters per line, with 18 lines
                    const maxLength = Math.max(
                        data.macro.text ? data.macro.text.length : 0,
                        data.micro.text ? data.micro.text.length : 0,
                        data.additionalReport.text ? data.additionalReport.text.length : 0,
                        data.diagnosis.text ? data.diagnosis.text.length : 0
                    )
                    if (maxLength) {
                        let calc = 45 * (Math.floor(maxLength / 25) + 2)
                        if (calc > 200) calc = 220
                        return calc
                    } else {
                        return 30
                    }
                }
            }
        }
    },
    async mounted() {
        const [err, response] = await this.toCall(samplesServices.getPreviousCasesSamples(this.$store.getters.labId, this.casId, this.patId))
        if (err) {
            this.showErrorModalGlobal()
        }
        this.rowData = response
        this.$emit('samplesCount', this.rowData.length)
    }
}
</script>

<style lang="scss">
.sample-grid .ag-body-viewport {
  overflow-y: auto !important;
  height: calc(100vh - 590px) !important;
}

@media (max-width: 1300px) {
  .sample-grid .ag-body-viewport {
    overflow-y: auto !important;
    height: calc(100vh - 530px) !important;
  }
}

@media only screen and (max-width: 1366px) and (min-width: 1360px) {
  .sample-grid .ag-body-viewport {
    overflow-y: auto !important;
    height: calc(100vh - 300px) !important;
  }
}
</style>
